/**
 *  全域常用變數。
 *  已在 `@/mixins/common.js` 中 import，所以可以在所有組件裡使用這些變數。
 */

// 後端伺服器 Domain
const server = 'https://us-central1-mc-integration-platform.cloudfunctions.net/'

// 組別編號 → 組別中文字串 對應表
const groupTable = {
  1: '個人',
  2: '自彈自唱',
  3: '團體',
  4: '鋼弦演奏',
  5: '鋼弦創作',
  6: '創作',
  7: '高中',
  8: '高中演唱',
  9: '高中演奏',
  10: '獨唱-國台語',
  11: '獨唱-外語',
  12: '獨唱',
  13: '重唱',
  14: '學生',
  15: '社會',
  16: '樂團',
  17: '演奏',
  18: '饒舌',
  19: '畢業歌',
  20: '大專個人',
  21: '大專團體',
  22: '大專創作',
  23: '大專演奏',
  24: '鋼弦',
  25: '本土語',
  26: '重/對唱',
  27: '學生獨唱',
  28: '社會獨唱',
  29: '重、對唱',
  30: '客語演唱',
}

// 設備 key → 設備中文字串 對應表
const equipmentTable = {
  mic: '麥克風',
  micStand: '麥架',
  guitar: '吉他',
  cajon: 'Cajon',
  KB: 'KB',
  bass: 'Bass',
  chair: '椅子',
  effector: '效果器',
  other: '備註',
}

// 不可數的設備 key。即將以字串顯示的那些設備之 key，如效果器等
const uncountableEquipmentList = ['effector', 'other']

// 比賽狀態編號 → 比賽狀態物件 對應表
const competitionStatusTable = {
  1: { name: '比賽結束', color: 'grey darken-1', icon: 'fas fa-stop' },
  2: { name: '進行中', color: 'red', icon: 'fas fa-music' },
  3: { name: '等待中', color: 'green', icon: 'fas fa-hourglass-half' },
  4: { name: '過號', color: 'brown darken-1', icon: '' },
  5: { name: '棄賽', color: 'amber darken-2', icon: '' },
}

// 選單項目列表
//   isExact: true 當路由完整匹配，選單項目才會是 active。
//   isSubheader: true 表示為小標題。
//   isDivider: true 表示為分割線。
const navbarItems = [
  { name: 'home', caption: '概覽', icon: 'dashboard', isExact: true },
  { isSubheader: true, caption: '後台管理' },
  { name: 'form', caption: '報名表單', icon: 'fab fa-wpforms' },
  { name: 'competition', caption: '賽況資訊', icon: 'fas fa-flag-checkered' },
  { name: 'manual', caption: '簡章', icon: 'fas fa-book-open' },
  { name: 'qa', caption: 'Q&A', icon: 'fas fa-question' },
  { name: 'lottery', caption: '抽獎', icon: 'fas fa-ticket-alt' },
  { name: 'vote', caption: '人氣投票', icon: 'fas fa-vote-yea' },
  { isDivider: true },
  {
    name: 'config',
    caption: '設定',
    icon: 'settings',
    isExact: true,
    description: '設定比賽資訊、日期、本屆賽制等',
  },
  {
    name: 'groupConfig',
    caption: '組別規則',
    icon: 'fas fa-users',
    description: '設定人數、報名費、器材數量等',
  },
]

// 賽制編號 → 賽制中文字串 對應表
const levelTable = {
  1: '初賽',
  2: '複賽',
  3: '決賽',
}

// 繳費狀態編號 → 繳費狀態物件 對應表
const formStatusTable = {
  1: { name: '已繳費', class: 'success--text font-weight-bold' },
  2: { name: '未繳費', class: '' },
  3: { name: '退賽', class: 'grey--text font-italic' },
}

// 學校類型列表
const schoolClassificationList = [
  // 地區
  { value: 'north', label: '北區' },
  { value: 'central', label: '中區' },
  { value: 'south', label: '南區' },
  // 學制
  { value: 'university', label: '大專組' },
  { value: 'society', label: '社會組' },
  { value: 'highSchool', label: '高中組' },
  // 表演類型
  { value: 'fingerstyle', label: '演奏類' },
  { value: 'original', label: '創作類' },
  { value: 'sing', label: '歌唱類' },
]

// payment key → payment 詳情標籤 對應表
const paymentKeyTable = {
  rtnCode: '狀態',
  tradeAmt: '應繳金額 NT$',
  expireDate: '繳費期限',
  bankCode: '銀行代碼',
  vAccount: '虛擬 ATM 帳號',
  paymentDate: '繳費時間',
}

// payment 付款狀態編號 → payment 付款狀態物件 對應表
const rtnCodeTable = {
  1: { name: '已付款', class: 'success--text' },
  2: { name: '等待付款', class: 'grey--text' },
}

// payment 各項目條列順序
const paymentKeyOrder = [
  'rtnCode',
  'paymentDate',
  'tradeAmt',
  'expireDate',
  'vAccount',
]

export default {
  server,
  groupTable,
  equipmentTable,
  uncountableEquipmentList,
  competitionStatusTable,
  navbarItems,
  levelTable,
  formStatusTable,
  schoolClassificationList,
  paymentKeyTable,
  rtnCodeTable,
  paymentKeyOrder,
}
